import React, { useState, useEffect } from "react";
import Button from "@hubins/components/Button";
import SearchInput from "components/SearchInput";
import { formatMoney } from "helpers";
import { LoadingBar } from "@hubins/components/LoadingIndicators";
import __ from "localisation";
import ApiPaginationTable from "modules/Tables/ApiPaginationTable";
import { Columns, Column } from "components/Columns";
import BackofficeProfileLink from "@hubins/components/BackofficeProfileLink";
import { useMiddleman } from "helpers/MiddlemanContext";
import BackofficePortfolioLink from "@hubins/components/BackofficePortfolioLink/BackofficePortfolioLink";
import './index.scss';

const loadingObj = {
  toolsBeginning: <LoadingBar small />,
  short_name: <LoadingBar small />,
  available_balance: <LoadingBar small />,
  market_value: <LoadingBar small />,
  profile: {
    name: <LoadingBar small />,
    national_identity_number: <LoadingBar small />,
  },
};

const loadingState = [loadingObj, loadingObj, loadingObj];

const headers = [
  {
    Header: "",
    accessor: "toolsBeginning",
    className: "rt-cell-button",
    width: 40,
  },
  {
    Header: __("name"),
    accessor: "profile.name",
    Cell: ({ row }) => (
      <>
        {row?.original?.profile?.name && (
          <BackofficeProfileLink profileUuid={row?.original?.profile?.uuid}>
            {row?.original?.profile?.name}
          </BackofficeProfileLink>
        )}
      </>
    ),
  },
  {
    Header: __("ssn_org_num"),
    accessor: "profile.national_identity_number",
    Cell: ({ row }) => (
      <>
        {row?.original?.profile?.national_identity_number && (
          <BackofficeProfileLink profileUuid={row?.original?.profile?.uuid}>
            {row?.original?.profile?.national_identity_number}
          </BackofficeProfileLink>
        )}
      </>
    ),
  },
  {
    Header: __("distributor"),
    accessor: "distributor",
  },
  {
    Header: __("policy"),
    accessor: "short_name",
    Cell: ({ row }) => (
      <>
        {row?.original?.short_name && (
          <BackofficePortfolioLink
            portfolioUuid={row?.original?.uuid}
            profileUuid={row?.original?.profile?.uuid}
          >
            {row?.original?.short_name}
          </BackofficePortfolioLink>
        )}
      </>
    ),
  },
  {
    Header: __("account_balance"),
    accessor: "available_balance",
    Cell: ({ row }) =>
      formatMoney(row.original.available_balance, row.original.currency),
  },
  {
    Header: __("market_value"),
    accessor: "market_value",
    Cell: ({ row }) =>
      formatMoney(row.original.market_value, row.original.currency),
  },
  {
    Header: __("updated_at"),
    accessor: "updated_at",
  },
  // {
  //   Header: __('created_at'),
  //   accessor: 'created_at'
  // },
];

const AllPortfolios = () => {
  const middleman = useMiddleman();

  const [portfolios, setPortfolios] = useState(false);
  const [amountOfPages, setAmountOfPages] = useState(-1);
  const [search, setSearch] = useState("");
  const [selectedPage, setSelectedPage] = useState(0);
  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchPage = (page, searchParam: boolean | string = false) => {
    setSelectedPage(page - 1);
    setLoading(true);
    middleman
      .get(
        `/ql/crm/portfolio/search?page=${page}${searchParam ? `&search=${searchParam}` : ""}`,
      )
      .then((res) => {
        const formattedRes = res.data.data.reduce(
          (portfoliosCollection, item) => {
            if (item.policy_holder && Array.isArray(item.policy_holder)) {
              item.policy_holder.forEach((profile) => {
                portfoliosCollection.push({
                  ...item,
                  profile: profile,
                  toolsBeginning: (
                    <Button
                      href={`/dashboard/clients/${profile.uuid}/${item.uuid}/tabs`}
                      className={`transparent`}
                      icon="arrow-right"
                      onlyIcon
                    />
                  ),
                });
              });
            }
            return portfoliosCollection;
          },
          [],
        );
        setAmountOfPages(res.data.last_page);
        setPortfolios(formattedRes);
        setLoading(false);
      });
  };

  const searchCallback = () => {
    fetchPage(1, search);
  };

  useEffect(() => {
    if (init) {
      const timeout = setTimeout(searchCallback, 1500);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [search]);

  const handlePageFetch = (index) => {
    fetchPage(index + 1, search);
    if (!init) {
      setInit(true);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <>
      <div className="flex flex--row align-items-center space-between all-portfolios__header">
        <SearchInput onChange={handleSearchChange} value={search} placeholder="Search client name, policy or SSN/Org-nr" loading={loading} className="all-portfolios__header-searchinput" />
        <Button href="/dashboard/create" icon="add" size="large">
          {__("create")}
        </Button>
      </div>
      <Columns>
        <Column s="12">
          <ApiPaginationTable
            data={portfolios ? portfolios : loadingState}
            headers={headers}
            fetchData={handlePageFetch}
            pageCount={amountOfPages}
            index={selectedPage}
          />
          {/* <ReactTable
          data={clients ? clients : loadingState}
          className={`ReactTable--striped ReactTable--highlight numbers`}
          columns={headers}
          pages={amountOfPages}
          pageSize={pageSize}
          manual
          previousText={__('previous')}
          nextText={__('next')}
          loadingText={<LoadingBar />}
          noDataText={__('no_data_found')}
          pageText={__('page')}
          ofText={__('of')}
          rowsText={__('rows')}
          loading={loading}
          onFetchData={handlePageFetch}
          showPageSizeOptions={false}
          page={selectedPage}
          showPageJump={false}
          sortable={false}
        /> */}
        </Column>
      </Columns>
    </>
  );
};

export default AllPortfolios;
